module.exports = __webpack_public_path__ + "static/media/Upload_Sample.a7415b75.csv";